import { API_URL } from "../../config/api";

export const STATUS_MAP = {
  planning: {
    label: "ĐANG QUY HOẠCH",
    bgColor: "bg-yellow-600",
    icon: "📐",
  },
  "under-construction": {
    label: "ĐANG THI CÔNG",
    bgColor: "bg-blue-600",
    icon: "🏗️",
  },
  ready: {
    label: "SẴN SÀNG",
    bgColor: "bg-green-600",
    icon: "✅",
  },
  "sold-out": {
    label: "ĐÃ BÁN HẾT",
    bgColor: "bg-gray-600",
    icon: "🚫",
  },
  inactive: {
    label: "NGƯNG HOẠT ĐỘNG",
    bgColor: "bg-red-600",
    icon: "⏸️",
  },
};

export const getStatusDetails = (status) =>
  STATUS_MAP[status] || {
    label: status,
    bgColor: "bg-gray-700",
    icon: "",
  };

export const getImages = (imageData) => {
  if (!imageData) return [];

  if (Array.isArray(imageData)) return imageData;

  if (typeof imageData === "string") {
    try {
      const parsed = JSON.parse(imageData);
      return Array.isArray(parsed) ? parsed : [parsed];
    } catch {
      return [imageData];
    }
  }

  return [];
};

export const getProjectImage = (imageData) => {
  const images = getImages(imageData);

  if (!images.length) {
    return "/placeholder.png";
  }

  return images[0].startsWith("http")
    ? images[0]
    : `${API_URL}${images[0]}`;
};

export const createProjectFormData = (project) => ({
  name: project?.name || "",
  slug: project?.slug || "",
  location: project?.location || "",
  priceRange: project?.priceRange || "",
  description: project?.description || "",
  status: project?.status || "planning",
  image: getImages(project?.image),
});